import { types } from 'mobx-state-tree';

export const EmploymentExperiences = types.model('EmploymentExperiencesModel', {
  startDate: types.maybeNull(types.Date),
  endDate: types.maybeNull(types.Date),
  position: types.maybe(types.string),
  company: types.maybe(types.string),
  duties: types.maybe(types.string),
  references: types.maybe(types.string),
});
